import { render, staticRenderFns } from "./body-name.vue?vue&type=template&id=03ce9319&scoped=true&"
import script from "./body-name.vue?vue&type=script&lang=js&"
export * from "./body-name.vue?vue&type=script&lang=js&"
import style0 from "./body-name.vue?vue&type=style&index=0&id=03ce9319&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ce9319",
  null
  
)

export default component.exports